import CircleFilledIconPath from "@ingka/ssr-icon/paths/circle-filled";

export default CircleFilledIconPath;
